import NewBusinessAddressDialog from '@/components/purchase_policy/NewBusinessAddressDialog.vue'
import { IAddressItem } from "@/models/Address";
import { clone } from "../utils";


export default {
    components: {
        NewBusinessAddressDialog
    },
    name: 'NewBusinessRegisteredService',
    props: {
        title: String,
        instruction: String
    },
    data() {
        return {
            addressDialogStatus: false,
            showModal: false,
            checkbox: true,
            mode: "ADD",
            activeAddress: new IAddressItem(this.$store),
            activeIndex: 0,
            savedAddresses: this.$store.state.sessionDetails.properties.addresses,
            session_id: '',

            addressSubmitted: false,
        }
    },
    methods: {
        onAddressDialogSave(event){
            if(this.mode === "ADD"){
                this.savedAddresses.push(event)
            } else{
                this.savedAddresses[this.activeIndex] = event
            }
            this.$store.commit('mutate', {
                property: "sessionDetails.properties.addresses",
                value: this.savedAddresses
            });
            this.updateAddressHandler();
            this.addressDialogStatus = false
        },
        onAddressDialogClose() {
            this.addressDialogStatus = false
        },
        checkStoreData() {
            console.debug('session_id', this.$store.state.sessionDetails.properties.session_id);
            console.debug('Payload Build Structure', this.$store.state.sessionDetails);
        },
        backToPrevious() {
            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep - 1
            });
        },
        initApp() {
            this.checkStoreData();
        },
        openDialog() {
            this.activeAddress = new IAddressItem()
            this.mode = "ADD"
            this.addressDialogStatus = true;
        },
        updateAddress(id) {
            this.activeAddress = this.savedAddresses[id]
            this.mode = "UPDATE"
            this.activeIndex = id
            this.addressDialogStatus = true
        }, 
        deleteAddress(index) {  
            this.savedAddresses.splice(index, 1)
            this.$store.commit('mutate', {
                property: "sessionDetails.properties.addresses",
                value: this.savedAddresses
            });
            this.updateAddressHandler();
        },
        updateAddressHandler() {
            // set index 0 as insured & mail address
            if (this.$store.state.sessionDetails.properties.addresses && this.$store.state.sessionDetails.properties.addresses.length === 1) { 
                let addresses = clone(this.$store.state.sessionDetails.properties.addresses);
                    addresses[0].is_mailing_address = true;
                    addresses[0].is_risk_address = true;
                this.updateAddressStore('addresses', addresses);
                this.updateAddressStore('insured_address', addresses[0]);
                this.updateAddressStore('mailing_address', addresses[0]);
            }
        },
        updateAddressStore(field, value) {
            let property = `sessionDetails.properties.${field}`;
            this.$store.commit('mutate', {
                property: property,
                value: value
            });
        },
        async submitForm() {
            let self = this;
            let validNSWArray = [];

            //lookup if there is NSW
            if(this.$store.state.sessionDetails.properties.addresses.length > 0) {
                this.addressSubmitted = true;
                let savedAddresesList = this.$store.state.sessionDetails.properties.addresses;

                var data = {
                    specs:[
                        { 
                            Name:"Power",
                            Value:"1"
                        }
                        ,{
                            Name:"Weight",
                            Value:"2"
                        },
                        {   Name:"Height",
                            Value:"3"
                        }
                    ]
                }

                savedAddresesList.forEach(function(data) {
                    let getState = data.address.state;
                    let risk_addess_state = data.is_risk_address;

                    if(getState == 'NSW' && risk_addess_state == true) {

                        validNSWArray.push({
                            state: data.address.state,
                            is_risk_address: data.is_risk_address
                        })

                    }

                });

            }

            if(validNSWArray.length > 0) {
                self.$store.commit('mutate', {
                    property: "NewBusinessHasValidNSWAddressAndAssignedToRisk",
                    value: true
                });
            }
            
            this.$emit("createUpdateSession");
            
        },
        assignToMailingAddress(index) {
            let allAddress = clone(this.$store.state.sessionDetails.properties.addresses);
            allAddress.forEach(item => {
                item.is_mailing_address = false;
            });
            allAddress[index].is_mailing_address = true;

            this.updateAddressStore('addresses', allAddress);
            this.updateAddressStore('mailing_address', allAddress[index]);

        },
        assignToRiskAddress(index) {
            let allAddress = clone(this.$store.state.sessionDetails.properties.addresses);
            allAddress.forEach(item => {
                item.is_risk_address = false;
            });
            allAddress[index].is_risk_address = true;

            this.updateAddressStore('addresses', allAddress);
            this.updateAddressStore('insured_address', allAddress[index]);
        }
    },
    mounted() {
        
        this.initApp(); 
    
    }
}